/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'COMMUNICATION_AND_TRAINING_BASED_UPON_WRITTEN_POLICIES_AND_OR_P',
              'COMMUNICATION_AND_TRAINING_BASED_UPON_INFORMAL_NOT_WRITTEN_PROC',
              'THE_FACILITY_DOES_NOT_PROVIDE_COMMUNICATION_AND_TRAINING_ON_SOC',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_prov_comm_and_training_on_social_and_labor_practic: valueSchema,
  },
}
